import { render } from "./PageHeader.vue?vue&type=template&id=23a13f54&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=23a13f54&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a13f54"]])

export default __exports__